import React from 'react';
import Loading from '../../Loading.js';
import Paper from 'material-ui/Paper';
import Menu from '../../components/Menu.js';
import { Redirect } from 'react-router';
import AppUserFilter from '../../components/NewAppUser/AppUserFilter'
import AppUserList from '../../components/NewAppUser/AppUserList'
import * as actions from '../../store/actions/index';
import { connect } from 'react-redux';

class AppUser extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loginRedirect: false,
      loading: false
    }
  }

  componentDidMount() {
    this.props.getRolesAndBusiness()
    this.props.getPlayerTypeList()
  }

  getFilterData = () => {
    return {
      max: this.props.max,
      offset: this.props.offset,
      sortBy: this.props.sortBy,
      column: this.props.currColumn,
      selectedRoles: this.props.selectedRoles,
      business: this.props.selectedBusiness,
      username: this.props.username,
      first_name: this.props.first_name,
      last_name: this.props.last_name,
      alias: this.props.alias,
      playerType: this.props.player_Type,
      assigned_to: this.props.selectedCoach,
      userRole: localStorage.getItem('userRole')
    }
  }

  render() {

    return (
      <div>
        {this.state.loading ? <Loading /> : null}
        {this.state.loginRedirect && (<Redirect to={'/'} />)}
        <Menu title={this.state.title} />
        <div className="container">
          <Paper zDepth={1} rounded={false} className="resp-paper">
            <AppUserFilter/>
          </Paper>
          <AppUserList
            usersList={this.props.usersList}
            getFilterData={this.getFilterData()}
            totalCount={this.props.totalCount}
            max={this.props.max}
            getUsersList={this.props.getUsersList}
          />
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    usersList: state.appUser.usersList,
    totalCount: state.appUser.totalCount,
    offset: state.appUser.offset,
    sortBy: state.appUser.sortBy,
    currColumn: state.appUser.currColumn,
    max: state.appUser.max,
    username: state.appUser.username,
    first_name: state.appUser.first_name,
    last_name: state.appUser.last_name,
    alias: state.appUser.alias,
    player_Type: state.appUser.player_type,
    selectedCoach: state.appUser.selectedCoach
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getRolesAndBusiness: () => dispatch(actions.getRolesAndBusiness()),
    onRoleChange: (value, roles) => dispatch(actions.onRoleChange(value, roles)),
    onBussChange: (value, business) => dispatch(actions.onBussChange(value, business)),
    getPlayerTypeList: () => dispatch(actions.getPlayerTypeList()),
    getUsersList: (data) => dispatch(actions.getUsersList(data))
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(AppUser);



/** WEBPACK FOOTER **
 ** ./src/container/AppUser/AppUser.js
 **/